import {getUserFirstName} from "../../user/utils/get_user_first_name";
import {NAVIGATION_LABELS} from "../constants/navigation_labels";

export const getProfileGreeting = (name?: string | null) => {
    const firstName = getUserFirstName(name);

    return firstName ? `${NAVIGATION_LABELS.PROFILE_GREETING.DESKTOP_PREFIX},\u00A0${firstName}!` : `${NAVIGATION_LABELS.PROFILE_GREETING.DESKTOP_PREFIX}!`;
};
import {getUserFirstName} from "../../user/utils/get_user_first_name";
import {NAVIGATION_LABELS} from "../constants/navigation_labels";

export const getProfileGreeting = (name?: string | null) => {
    const firstName = getUserFirstName(name);

    return firstName ? `${NAVIGATION_LABELS.PROFILE_GREETING.DESKTOP_PREFIX},\u00A0${firstName}!` : `${NAVIGATION_LABELS.PROFILE_GREETING.DESKTOP_PREFIX}!`;
};
